/**
 * 环境变量
 */
export const Env = {
  /** 接口地址 */
  BaseApiUrl: process.env.BASE_API_URL,
};

/**
 * 路由地址
 */
export const RouterName = {
  /** ====================================================================公共==================================================================== */
  /** 登录 */
  Login: '/login',
  /** 用户管理 */
  UserManage: '/manage/setting/user/list',
  /** ==================监管平台=========================== */
  /** ====================================================================aio平台==================================================================== */
  /** AIO登录 */
  AioLogin: '/aio/login',
  /** 权限创建 */
  AioPermissionCreate: '/aio/permission/create',
  /** 权限列表 */
  AioPermissionList: '/aio/permission/list',
  /** 营养成分 */
  AioNutrientList: '/aio/nutrient/list',
  /** 数据仓库 */
  AioDataWarehouseLits: '/aio/data_warehouse/list',
  /** ====================================================================监管平台==================================================================== */
  /** 采购需求汇总 */
  ManagePurchaseSummaryList: '/manage/purchase_summary/list',
  /** 需方组汇总表 */
  ManageDemandGroupReportList: '/manage/report/demand_group_report/list',
  /** 采购商品备注 */
  ManagePurchaseSkuRemarkList: '/manage/purchase_order/purchase_sku_remark/list',
  /** 明厨亮灶 */
  ManageBrightKitchen: '/manage/bright_kitchen',
  /** 明厨亮灶全屏 */
  ManageBrightKitchenFullScreen: '/manage/bright_kitchen/full_screen',
  /** 违规记录 */
  ManageViolationRecordList: '/manage/violation_record/list',
  /** 滞销品列表 */
  ManageDeadStockList: '/manage/commodity/dead_stock/list',
  /** 就餐日历 */
  ManageDiningCalendarList: '/manage/cookbook/dining_calendar/list',
  /** 巡检任务 */
  ManageInspectionTaskList: '/manage/inspection_task/list',
  /** 巡检任务详情 */
  ManageInspectionTaskDetail: '/manage/inspection_task/detail',
  /** 留样 */
  ManageKeepSampleList: '/manage/keep_sample/list',
  /** 留样详情 */
  ManageKeepSampleDetail: '/manage/keep_sample/detail',
  /** 消杀列表 */
  ManageDisinfectList: '/manage/disinfect/list',
  /** 消杀详情 */
  ManageDisinfectDetail: '/manage/disinfect/detail',
  /** 晨检列表 */
  ManageMorningCheckList: '/manage/morning_check/list',
  /** 晨检详情 */
  ManageMorningCheckDetail: '/manage/morning_check/detail',
  /** 项目列表 */
  ManageProjectList: '/manage/inquiry_quotation/project_manage/list',
  /** 项目详情 */
  ManageProjectDetail: '/manage/inquiry_quotation/project_manage/detail',
  /** 项目详情-单号查询 */
  ManageProjectDetailByNo: '/manage/inquiry_quotation/project_manage/detail_no',
  /** 项目新建 */
  ManageProjectCreate: '/manage/inquiry_quotation/project_manage/create',
  /** 项目编辑 */
  ManageProjectEdit: '/manage/inquiry_quotation/project_manage/edit',
  /** 项目复制 */
  ManageProjectCopy: '/manage/inquiry_quotation/project_manage/copy',
  /** 项目评标定标 */
  ManageProjectEvaluate: '/manage/inquiry_quotation/project_manage/evaluate',
  /** 新品提报 */
  ManageNewSubmissionList: '/manage/commodity/new_submission/list',
  /** 投诉建议 */
  ManageSuggestionList: '/manage/suggestion/list',
  /** 财务汇总表 */
  ManageFinancialReportList: '/manage/report/finance_report/list',
  /** 报餐记录 */
  ManageMealRecordList: '/manage/cookbook/meal_record/list',
  /** 报餐记录详情 */
  ManageMealRecordDetail: '/manage/cookbook/meal_record/detail',
  /** 新建报餐记录 */
  ManageMealRecordCreate: '/manage/cookbook/meal_record/create',
  /** 编辑报餐记录 */
  ManageMealRecordEdit: '/manage/cookbook/meal_record/edit',
  /** 套餐需求汇总 */
  ManagePackageSummaryList: '/manage/cookbook/package_summary/list',
  /** 餐标汇总 */
  MealSummaryList: '/manage/cookbook/meal_summary/list',
  /** 餐标管理 */
  MealStandardList: '/manage/cookbook/meal_standard/list',
  /** 标签管理 */
  ManageTagList: '/manage/setting/tag_manage/list',
  /** 限价管理 */
  LimitPriceList: '/manage/inquiry_quotation/limit_price/list',
  /** 统一定价 */
  UniformPriceList: '/manage/inquiry_quotation/uniform_price/list',
  /** 周转筐统计 */
  BasketStatisticsList: '/manage/basket_statistics/list',
  /** 周转筐借还记录 */
  TurnoverBasketList: '/manage/turnover_basket/list',
  /** 周转筐借还记录详情 */
  TurnoverBasketDetail: '/manage/turnover_basket/detail',
  /** 新建周转筐借还记录 */
  TurnoverBasketCreate: '/manage/turnover_basket/create',
  /** 编辑周转筐借还记录 */
  TurnoverBasketEdit: '/manage/turnover_basket/edit',
  /** 开票记录 */
  ManageBillRecordList: '/manage/bill/bill_record/list',
  /** 开票记录详情 */
  ManageBillRecordDetail: '/manage/bill/bill_record/detail',
  /** 新建开票记录 */
  ManageBillRecordCreate: '/manage/bill/bill_record/create',
  /** 编辑开票记录 */
  ManageBillRecordEdit: '/manage/bill/bill_record/edit',
  /** 配送任务 */
  ManageDeliveryTaskList: '/manage/delivery_task/list',
  /** 新建配送任务 */
  ManageDeliveryTaskCreate: '/manage/delivery_task/create',
  /** 编辑配送任务 */
  ManageDeliveryTaskEdit: '/manage/delivery_task/edit',
  /** 配送任务详情 */
  ManageDeliveryTaskDetail: '/manage/delivery_task/detail',
  /** 配送任务一键排线 */
  ManageDeliveryTaskQuickWiring: '/manage/delivery_task/quick_wiring',
  /** 配送路线列表 */
  ManageDeliveryRouteList: '/manage/delivery_route/list',
  /** 新建配送路线 */
  ManageDeliveryRouteCreate: '/manage/delivery_route/create',
  /** 编辑配送路线 */
  ManageDeliveryRouteEdit: '/manage/delivery_route/edit',
  /** 配送路线详情 */
  ManageDeliveryRouteDetail: '/manage/delivery_route/detail',
  /** 溯源管理 */
  ManageSuyuanManage: '/manage/suyuan',
  /** 库存台账 */
  ManageInventoryStock: '/manage/inventory_stock/list',
  /** 实时库存 */
  ManageInventoryRealtime: '/manage/inventory_realtime',
  /** 价格监控 */
  ManagePriceMonitor: '/manage/inquiry_quotation/monitor/list',
  /** 账户管理 */
  AccountList: '/manage/bill/account/list',
  /** 公告管理 */
  NoticeList: '/manage/setting/notice/list',
  /** 监管方非监管商品列表 */
  ManageUnsuperviseCommodityList: '/manage/unsupervise_commodity/list',
  /** 监管方非监管商品详情 */
  ManageUnsuperviseCommodityDetail: '/manage/unsupervise_commodity/detail',
  /** 缴费单 */
  PaymentReceipt: '/manage/cookbook/payment_receipt/list',
  /** 缴费单详情 */
  PaymentReceiptDetail: '/manage/cookbook/payment_receipt/detail',
  /** 缴费单新增 */
  PaymentReceiptCreate: '/manage/cookbook/payment_receipt/create',
  /** 缴费单编辑 */
  PaymentReceiptEdit: '/manage/cookbook/payment_receipt/edit',
  /** 缴费单报餐记录 */
  MealRecordDetail: '/manage/cookbook/meal_record/detail',
  /** 自用菜谱 */
  ManageSelfCookbook: '/manage/cookbook/self_cookbook/list',
  /** 自用菜谱详情 */
  ManageSelfCookbookDetail: '/manage/cookbook/self_cookbook/detail',
  /** 菜谱管理 */
  ManageCookbookList: '/manage/cookbook/cookbook_manage/list',
  /** 菜谱详情 */
  ManageCookbookDetail: '/manage/cookbook/cookbook_manage/detail',
  /** 新建公用菜谱 */
  ManageCookbookCreate: '/manage/cookbook/cookbook_manage/create',
  /** 复制公用菜谱 */
  ManageCookbookCopy: '/manage/cookbook/cookbook_manage/copy',
  /** 编辑公用菜谱 */
  ManageCookbookEdit: '/manage/cookbook/cookbook_manage/edit',
  /** 组合商品列表 */
  ProductCombinationList: '/manage/commodity/product_combination/list',
  /** 组合商品详情 */
  ProductCombinationDetail: '/manage/commodity/product_combination/detail',
  /** 组合商品编辑 */
  ProductCombinationEdit: '/manage/commodity/product_combination/edit',
  /** 组合商品新增 */
  ProductCombinationAdd: '/manage/commodity/product_combination/add',
  /** 验证收货记录 */
  ReceiptRecordList: '/manage/trade/product_combination/list',
  /** 申购单 */
  ApplyPurchaseList: '/manage/apply_purchase/list',
  /** 申购单详情 */
  ApplyPurchaseDetail: '/manage/apply_purchase/detail',
  /** 下达采购 */
  ApplySendPurchase: '/manage/apply_purchase/send_purchase',
  /** 编辑申购单 */
  ApplyPurchaseEdit: '/manage/apply_purchase/edit',
  /** 申购需求汇总 */
  ApplyPurchaseSummary: '/manage/apply_purchase/purchase_summary/list',
  /** 商品列表 */
  CommodityList: '/manage/commodity/list',
  /** 创建商品 */
  CommodityCreate: '/manage/commodity/create',
  /** 转商品 */
  CommodityTransferProduct: '/manage/commodity/transfer_product',
  /** 编辑商品 */
  CommodityUpdate: '/manage/commodity/update',
  /** 商品详情 */
  CommodityDetail: '/manage/commodity/detail',
  /** 创建列表 */
  PurchaserCreate: '/manage/incoming/purchaser/create',
  /** 需方列表 */
  PurchaserList: '/manage/incoming/purchaser/list',
  /** 需方详情 */
  PurchaserDetails: '/manage/incoming/purchaser/details',
  /** 需方编辑 */
  PurchaserUpdate: '/manage/incoming/purchaser/update',
  /** 供方列表 */
  IncomingSupplierList: '/manage/incoming/supplier/list',
  /** 供方创建 */
  IncomingSupplierCreate: '/manage/incoming/supplier/create',
  /** 供方创建 */
  IncomingSupplierEdit: '/manage/incoming/supplier/edit',
  /** 供方详情 */
  IncomingSupplierDetail: '/manage/incoming/supplier/detail',
  /** 采购合同列表 */
  PurchaserContractList: '/manage/purchase_contract/list',
  /** 新建采购合同 */
  PurchaserContractCreate: '/manage/purchase_contract/create',
  /**
   * 复制采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractCopy}/${id}
   * */
  PurchaserContractCopy: '/manage/purchase_contract/copy',
  /**
   * 编辑采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractEdit}/${id}
   * */
  PurchaserContractEdit: '/manage/purchase_contract/edit',
  /**
   * 从报价单新增采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractAddForQuation}/${id}
   * */
  PurchaserContractAddForQuation: '/manage/purchase_contract/quotation/add',
  /**
   * 采购合同详情
   * @param string id 采购合同id
   * @description 使用方式 ${PurchaserContractDetail}/${id}
   * */
  PurchaserContractDetail: '/manage/purchase_contract/detail',
  /** 报价单列表 */
  ManageQuotationList: '/manage/inquiry_quotation/quotation/list',
  /** 报价单详情 */
  ManageQuotationDetail: '/manage/inquiry_quotation/quotation/detail',
  /** 报价单详情-单号查询 */
  ManageQuotationDetailByNo: '/manage/inquiry_quotation/quotation/detail_no',
  /** 报价单编辑 */
  ManageQuotationUpdate: '/manage/inquiry_quotation/quotation/update',
  /** 报价单创建 */
  ManageQuotationCreate: '/manage/inquiry_quotation/quotation/create',
  /** 报价单复制 */
  ManageQuotationCopy: '/manage/inquiry_quotation/quotation/copy',
  /** 创建采购单 */
  ManagePurchaseOrderCreate: '/manage/purchase_order/create',
  /** 采购单复制 */
  ManagePurchaseOrderCopy: '/manage/purchase_order/copy',
  /** 采购单补录 */
  ManagePurchaseOrderRepair: '/manage/purchase_order/repair',
  /**
   * 采购单列表
   */
  ManagePurchaseOrderList: '/manage/purchase_order/list',
  /**
   * 采购单详情
   */
  ManagePurchaseOrderDetail: '/manage/purchase_order/detail',
  /**
   * 采购单编辑
   */
  ManagePurchaseOrderEdit: '/manage/purchase_order/edit',
  ReconciliationListForManage: '/manage/bill/reconciliation/list',
  ReconciliationListByPaymentForManage: '/manage/bill/reconciliation/list',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetailForManage}/${statementNo}
   * */
  ReconciliationDetailForManage: '/manage/bill/reconciliation/detail',
  /** 编辑对账单 */
  ReconciliationEditForManage: '/manage/bill/reconciliation/edit',
  /** 询价单列表 */
  InquiryList: '/manage/inquiry_quotation/inquiry/list',
  /** 询价单创建 */
  InquiryCreate: '/manage/inquiry_quotation/inquiry/create',
  /** 询价单详情 */
  InquiryDetail: '/manage/inquiry_quotation/inquiry/detail',
  /** 询价单编辑 */
  InquiryEdit: '/manage/inquiry_quotation/inquiry/edit',
  /** 询价单复制 */
  InquiryCopy: '/manage/inquiry_quotation/inquiry/copy',
  /** 采购汇总表 */
  PurchaseReportList: '/manage/report/purchase_report/list',
  /** 食安统计表 */
  FoodSafetyReportList: '/manage/report/food_safety_report/list',
  /** 角色创建 */
  ManageRoleCreate: '/manage/role/create',
  /** 角色列表 */
  ManageRoleList: '/manage/role/list',
  /**
   * 角色编辑
   * ?roleId=${id}
   * */
  ManageRoleEdit: '/manage/role/editor',
  /**
   * 监管方供方绩效
   */
  ManagePerformanceList: '/manage/performance/list',
  /** 监管方实时监控全屏 */
  ManageRealtimeMonitor: '/manage/monitor/realtime_monitor',
  /** 监管方实时监控全屏 */
  ManageRealtimeMonitorFullScreen: '/manage/monitor/realtime_monitor_full_screen',
  /** 缴费记录 */
  PaymentRecords: '/manage/cookbook/payment_records/list',
  /** 缴费记录新建 */
  PaymentRecordsCreate: '/manage/cookbook/payment_records/create',
  /** 售后单 */
  AfterSales: '/manage/after_sales/list',
  /** 新增售后单 */
  AfterSalesCreate: '/manage/after_sales/create',
  /** 售后单详情 */
  AfterSalesDetail: '/manage/after_sales/detail',
  /** 售后单编辑 */
  AfterSalesEdit: '/manage/after_sales/edit',
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/manage/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/manage/bill/reconciliation/detail',
  /** 折扣定价单 */
  DiscountPriceList: '/manage/inquiry_quotation/discount_price/list',
  /** 折扣定价单详情 */
  DiscountPricesDetail: '/manage/inquiry_quotation/discount_price/detail',
  /** 折扣定价单编辑 */
  DiscountPricesEdit: '/manage/inquiry_quotation/discount_price/edit',
  /** 折扣定价单创建 */
  DiscountPricesCreate: '/manage/inquiry_quotation/discount_price/create',
  /** 折扣定价单复制 */
  DiscountPricesCopy: '/manage/inquiry_quotation/discount_price/copy',
  /** 折扣定价比价定价 */
  DiscountComparePrice: '/manage/inquiry_quotation/discount_price/compare_price',
  /** 折扣定价生成采购合同 */
  DiscountPurchaseContract: '/manage/inquiry_quotation/discount_price/purchase_contract',
  /** 商品行情价 */
  MarketPriceList: '/manage/inquiry_quotation/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/manage/inquiry_quotation/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/manage/inquiry_quotation/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/manage/inquiry_quotation/market_price/create',
  /** 商品行情价复制 */
  MarketPricesCopy: '/manage/inquiry_quotation/market_price/copy',
  /** 需方画像 */
  PurchaserPortraitList: '/manage/incoming/purchaser_portrait/list',
  /** 司机绩效 */
  DriverPerformanceList: '/manage/driver_performance/list',

  /** ====================================================================供方平台==================================================================== */
  /** 采购商品备注 */
  SupplyPurchaseSkuRemarkList: '/supply/purchase_order/purchase_sku_remark/list',
  /** 采购明细表 */
  SupplyPurchaseDetailReportList: '/supply/report/purchase_detail_report/list',
  /** 项目公示列表 */
  SupplyProjectPublicList: '/supply/report/project_public/list',
  /** 项目公示结果 */
  SupplyProjectPublicResult: '/supply/report/project_public/result',
  /** 项目列表 */
  SupplyProjectManageList: '/supply/inquiry_quotation/project_manage/list',
  /** 项目详情 */
  SupplyProjectManageDetail: '/supply/inquiry_quotation/project_manage/detail',
  /** 项目详情-单号查询 */
  SupplyProjectManageDetailByNo: '/supply/inquiry_quotation/project_manage/detail_no',
  /** 滞销品列表 */
  SupplyDeadStockList: '/supply/commodity/dead_stock/list',
  /** 商品税率 */
  SupplyTaxRateList: '/supply/commodity/tax_rate/list',
  /** 报餐记录 */
  SupplyMealRecordList: '/supply/purchase_order/meal_record/list',
  /** 报餐记录详情 */
  SupplyMealRecordDetail: '/supply/purchase_order/meal_record/detail',
  /** 套餐需求汇总 */
  SupplyPackageSummaryList: '/supply/purchase_order/package_summary/list',
  /** 套餐管理 */
  SupplyPackageManageList: '/supply/commodity/package_manage/list',
  /** 新建套餐 */
  SupplyPackageManageCreate: '/supply/commodity/package_manage/create',
  /** 套餐详情 */
  SupplyPackageManageDetail: '/supply/commodity/package_manage/detail',
  /** 套餐编辑 */
  SupplyPackageManageEdit: '/supply/commodity/package_manage/edit',
  /** 财务汇总表 */
  SupplyFinancialReportList: '/supply/report/financial_report/list',
  /** 询价公示 */
  SupplyInquiryPublic: '/supply/report/inquiry_public/list',
  /** 公示结果 */
  SupplyPublicResult: '/supply/report/inquiry_public/result',
  /** 收支管理 */
  SupplyIncomeExpenseList: '/supply/bill/income_expense/list',
  /** 周转筐管理 */
  SupplyTurnoverBasketList: '/supply/turnover_basket/list',
  /** 周转筐详情 */
  SupplyTurnoverBasketDetail: '/supply/turnover_basket/detail',
  /** 新建周转筐借还记录 */
  SupplyTurnoverBasketCreate: '/supply/turnover_basket/create',
  /** 编辑周转筐借还记录 */
  SupplyTurnoverBasketEdit: '/supply/turnover_basket/edit',
  /** 周转筐统计 */
  SupplyBasketStatisticsList: '/supply/basket_statistics/list',
  /** 员工管理 */
  SupplierEmployeeList: '/supply/setting/employee/list',
  /** 商品列表 */
  SupplyUnsuperviseCommodityList: '/supply/unsupervise_commodity/list',
  /** 创建商品 */
  SupplyUnsuperviseCommodityCreate: '/supply/unsupervise_commodity/create',
  /** 编辑商品 */
  SupplyUnsuperviseCommodityUpdate: '/supply/unsupervise_commodity/update',
  /** 商品详情 */
  SupplyUnsuperviseCommodityDetail: '/supply/unsupervise_commodity/detail',
  /** 采购单编辑 */
  SupplyPurchaseOrderEdit: '/supply/purchase_order/edit',
  /** 报价管理 */
  QuotationList: '/supply/inquiry_quotation/quotation/list',
  /** 质检报告 */
  CommodityQualityReportList: '/supply/commodity/quality_inspection/list',
  /** 询价单详情 */
  SupplyInquiryDetail: '/supply/inquiry_quotation/inquiry/detail',
  /** 询价单复制 */
  SupplyInquiryCopy: '/supply/inquiry_quotation/inquiry/copy',
  /** 询价列表 */
  SupplyAdminInquiryList: '/supply/inquiry_quotation/inquiry/list',
  /** 报价单列表 */
  SupplyQuotationList: '/supply/inquiry_quotation/quotation/list',
  /** 报价单详情 */
  SupplyQuotationDetail: '/supply/inquiry_quotation/quotation/detail',
  /** 报价单详情 */
  SupplyQuotationDetailByNo: '/supply/inquiry_quotation/quotation/detail_no',
  /** 报价单编辑 */
  SupplyQuotationUpdate: '/supply/inquiry_quotation/quotation/update',
  /** 报价单创建 */
  SupplyQuotationCreate: '/supply/inquiry_quotation/quotation/create',
  /** 报价单创建 */
  SupplyQuotationCreateByInquiry: '/supply/inquiry_quotation/quotation/create_by_inquiry',
  /** 报价单创建 */
  SupplyQuotationCreateByProject: '/supply/inquiry_quotation/quotation/create_by_project',
  /** 报价单复制 */
  SupplyQuotationCopy: '/supply/inquiry_quotation/quotation/copy',
  /** 新建采购合同 */
  SupplyPurchaserContractCreate: '/supply/purchase_contract/create',
  /** 采购合同列表 */
  SupplyPurchaserContractList: '/supply/purchase_contract/list',
  /**
   * 采购合同详情
   * @param string id 采购合同id
   * @description 使用方式 ${SupplyPurchaserContractDetail}/${id}
   * */
  SupplyPurchaserContractDetail: '/supply/purchase_contract/detail',
  /** 采购合同详情-通过编号查询 */
  SupplyPurchaserContractDetailByNo: '/supply/purchase_contract/detail_no',
  /**
   * 编辑采购合同
   * @param string id 采购合同id
   * @description 使用方式 ${SupplyPurchaserContractEdit}/${id}
   * */
  SupplyPurchaserContractEdit: '/supply/purchase_contract/edit',
  SupplyPurchaserContractCopy: '/supply/purchase_contract/copy',
  ReconciliationListForSupply: '/supply/bill/reconciliation/list',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetailForSupply}/${statementNo}
   * */
  ReconciliationDetailForSupply: '/supply/bill/reconciliation/detail',
  /** 采购单列表 */
  SupplyPurchaseOrderList: '/supply/purchase_order/list',
  /** 采购单详情 */
  SupplyPurchaseOrderDetail: '/supply/purchase_order/detail',
  /** 采购汇总表 */
  SupplyPurchaseReportList: '/supply/report/purchase_report/list',
  /** 经营分析 */
  SupplyBusinessAnalysisList: '/supply/report/business_analysis/list',
  /** 采购需求汇总 */
  PurchaseRequireSummary: '/supply/purchase_order/summary/list',
  /** 应收汇总 */
  ReceivableSummary: '/supply/bill/receivable/list',
  /** 开票记录列表 */
  BillRecordList: '/supply/bill/bill_record/list',
  /** 开票记录详情 */
  BillRecordDetail: '/supply/bill/bill_record/detail',
  /** 开票记录创建 */
  BillRecordCreate: '/supply/bill/bill_record/create',
  /** 开票记录编辑 */
  BillRecordEdit: '/supply/bill/bill_record/edit',
  /** 角色创建 */
  SupplyRoleCreate: '/supply/role/create',
  /** 角色列表 */
  SupplyRoleList: '/supply/role/list',
  /**
   * 角色编辑
   * ?roleId=${id}
   * */
  SupplyRoleEdit: '/supply/role/editor',
  /** 车辆 */
  SupplyDeliveryCarList: '/supply/delivery_car/list',
  /** 配送任务 */
  SupplyDeliveryTaskList: '/supply/delivery_task/list',
  /** 新建配送任务 */
  SupplyDeliveryTaskCreate: '/supply/delivery_task/create',
  /** 编辑配送任务 */
  SupplyDeliveryTaskEdit: '/supply/delivery_task/edit',
  /** 配送任务详情 */
  SupplyDeliveryTaskDetail: '/supply/delivery_task/detail',
  /** 配送任务一键排线 */
  SupplyDeliveryTaskQuickWiring: '/supply/delivery_task/quick_wiring',
  /** 配送路线列表 */
  SupplyDeliveryRouteList: '/supply/delivery_route/list',
  /** 新建配送路线 */
  SupplyDeliveryRouteCreate: '/supply/delivery_route/create',
  /** 编辑配送路线 */
  SupplyDeliveryRouteEdit: '/supply/delivery_route/edit',
  /** 配送路线详情 */
  SupplyDeliveryRouteDetail: '/supply/delivery_route/detail',
  /** 监管方实时监控全屏 */
  SupplyRealtimeMonitor: '/supply/monitor/realtime_monitor',
  /** 监管方实时监控全屏 */
  SupplyRealtimeMonitorFullScreen: '/supply/monitor/realtime_monitor_full_screen',
  /** ====================================================================需方平台==================================================================== */
  /** 库存明细表 */
  StockDetailReportList: '/purchaser/report/stock_detail_report/list',
  /** 采购明细表 */
  PurchaseDetailReportList: '/purchaser/report/purchase_detail_report/list',
  /** 档口 */
  PurchaseStallList: '/purchaser/setting/stall/list',
  /** 新建档口 */
  PurchaseStallCreate: '/purchaser/setting/stall/create',
  /** 编辑档口 */
  PurchaseStallEdit: '/purchaser/setting/stall/edit',
  /** 档口详情 */
  PurchaseStallDetail: '/purchaser/setting/stall/detail',
  /** 食堂 */
  PurchaseDiningList: '/purchaser/setting/dining/list',
  /** 新建食堂 */
  PurchaseDiningCreate: '/purchaser/setting/dining/create',
  /** 编辑食堂 */
  PurchaseDiningEdit: '/purchaser/setting/dining/edit',
  /** 食堂详情 */
  PurchaseDiningDetail: '/purchaser/setting/dining/detail',
  /** 仓库管理 */
  PurchaseWarehouseList: '/purchaser/inventory/warehouse/list',
  /** 明厨亮灶 */
  PurchaseBrightKitchen: '/purchaser/operate/bright_kitchen',
  /** 明厨亮灶全屏 */
  PurchaseBrightKitchenFullScreen: '/purchaser/operate/bright_kitchen/full_screen',
  /** 违规记录 */
  PurchaseViolationRecordList: '/purchaser/operate/violation_record/list',
  /** 项目公示列表 */
  PurchaseProjectManageList: '/purchaser/report/project_public/list',
  /** 项目公示结果 */
  PurchaseProjectManageResult: '/purchaser/report/project_public/result',
  /** 报价单详情 */
  PurchaseProjectQuotationDetail: '/purchaser/report/project_public/quotation_detail',
  /** 就餐日历 */
  PurchaserDiningCalendarList: '/purchaser/cookbook/dining_calendar/list',
  /** 新建陪餐记录 */
  AccompanyCreatePurchaser: '/purchaser/operate/accompany_meal/create',
  /** 编辑陪餐记录 */
  AccompanyEditPurchaser: '/purchaser/operate/accompany_meal/edit',
  /** 陪餐记录 */
  AccompanyListPurchaser: '/purchaser/operate/accompany_meal/list',
  /** 消杀列表 */
  PurchaserDisinfectList: '/purchaser/operate/disinfect/list',
  /** 消杀详情 */
  PurchaserDisinfectDetail: '/purchaser/operate/disinfect/detail',
  /** 新建消杀记录 */
  PurchaserDisinfectCreate: '/purchaser/operate/disinfect/create',
  /** 编辑消杀记录 */
  PurchaserDisinfectEdit: '/purchaser/operate/disinfect/edit',
  /** 晨检列表 */
  PurchaserMorningCheckList: '/purchaser/operate/morning_check/list',
  /** 晨检记录详情 */
  PurchaserMorningCheckDetail: '/purchaser/operate/morning_check/detail',
  /** 新建晨检记录 */
  PurchaserMorningCheckCreate: '/purchaser/operate/morning_check/create',
  /** 编辑晨检记录 */
  PurchaserMorningCheckEdit: '/purchaser/operate/morning_check/edit',
  /** 新品提报 */
  NewSubmissionList: '/purchaser/purchase_order/new_submission/list',
  /** 报餐记录 */
  PurchaserMealRecordList: '/purchaser/cookbook/meal_record/list',
  /** 报餐记录详情 */
  PurchaserMealRecordDetail: '/purchaser/cookbook/meal_record/detail',
  /** 编辑报餐记录 */
  PurchaserMealRecordEdit: '/purchaser/cookbook/meal_record/edit',
  /** 新建报餐记录 */
  PurchaserMealRecordCreate: '/purchaser/cookbook/meal_record/create',
  /** 报餐规则 */
  PurchaserMealRulesList: '/purchaser/cookbook/meal_rules/list',
  /** 投诉建议列表 */
  PurchaserSuggestionList: '/purchaser/operate/suggestion/list',
  /** 补货规则 */
  PurchaserReplenishList: '/purchaser/inventory/replenish_rules/list',
  /** 商品预警 */
  PurchaserProductWarningList: '/purchaser/inventory/product_warning/list',
  /** 开票记录列表 */
  PurchaserBillRecordList: '/purchaser/payment_statements/bill_record/list',
  /** 开票记录详情 */
  PurchaserBillRecordDetail: '/purchaser/payment_statements/bill_record/detail',
  /** 申领单列表 */
  PurchaserRequisitionList: '/purchaser/inventory/requisition/list',
  /** 申领单详情 */
  PurchaserRequisitionDetail: '/purchaser/inventory/requisition/detail',
  /** 申领单编辑 */
  PurchaserRequisitionEdit: '/purchaser/inventory/requisition/edit',
  /** 申领单创建 */
  PurchaserRequisitionCreate: '/purchaser/inventory/requisition/create',
  /** 申领单完成 */
  PurchaserRequisitionComplete: '/purchaser/inventory/requisition/complete',
  /** 申领单打印 */
  PurchaserRequisitionPrint: '/purchaser/inventory/requisition/print',
  /** 留样管理 */
  KeepSamplePurchaser: '/purchaser/operate/keep_sample/list',
  /** 新增留样管理 */
  KeepSamplePurchaserCreate: '/purchaser/operate/keep_sample/create',
  /** 留样管理详情 */
  KeepSamplePurchaserDetail: '/purchaser/operate/keep_sample/detail',
  /** 留样管理编辑 */
  KeepSamplePurchaserEdit: '/purchaser/operate/keep_sample/edit',
  /** 巡检任务 */
  PurchaserOperateInspectionList: '/purchaser/operate/inspection/list',
  /** 新建巡检任务 */
  PurchaserOperateInspectionCreate: '/purchaser/operate/inspection/create',
  /** 编辑巡检任务 */
  PurchaserOperateInspectionEdit: '/purchaser/operate/inspection/edit',
  /** 完成巡检任务 */
  PurchaserOperateInspectionDetail: '/purchaser/operate/inspection/detail',
  /** 巡检任务模版列表 */
  PurchaserOperateTaskTemplateList: '/purchaser/operate/task_template/list',
  /** 新建巡检任务模版 */
  PurchaserOperateTaskTemplateCreate: '/purchaser/operate/task_template/create',
  /** 编辑巡检任务模版 */
  PurchaserOperateTaskTemplateEdit: '/purchaser/operate/task_template/edit',
  /** 下达采购 */
  ApplySendPurchasePurchaser: '/purchaser/apply_purchase/send_purchase',
  /** 溯源管理 */
  PurchaseSuyuanManage: '/purchaser/purchase_order/suyuan',
  /** 账户管理 */
  TurnoverListTurnover: '/purchaser/payment_statements/account_turnover/list',
  /** 物料转换 */
  MaterialConversionPurchaser: '/purchaser/inventory/material_conversion/list',
  /** 新增物料转换 */
  MaterialConversionAddPurchaser: '/purchaser/inventory/material_conversion/add',
  /** 编辑物料转换 */
  MaterialConversionEditPurchaser: '/purchaser/inventory/material_conversion/edit',
  /** 物料转换详情 */
  MaterialConversionDetailPurchaser: '/purchaser/inventory/material_conversion/detail',
  /** 批量物料转换 */
  MaterialConversionBatchPurchaser: '/purchaser/inventory/material_conversion/batch_add',
  /** 盘点单管理 */
  InventorySheetPurchaser: '/purchaser/inventory/inventory_sheet/list',
  /** 新增盘点单 */
  InventorySheetAddPurchaser: '/purchaser/inventory/inventory_sheet/add',
  /** 编辑盘点单 */
  InventorySheetEditPurchaser: '/purchaser/inventory/inventory_sheet/edit',
  /** 盘点单详情 */
  InventorySheetDetailPurchaser: '/purchaser/inventory/inventory_sheet/detail',
  /** 盘点 */
  InventoryPurchaser: '/purchaser/inventory/inventory_sheet/inventory',
  /** 过账 */
  PostedPurchaser: '/purchaser/inventory/inventory_sheet/posted',
  /** 班级管理 */
  ClassPurchaser: '/purchaser/cookbook/class_manage/list',
  /** 就餐人员 */
  DinePersonnelPurchaser: '/purchaser/cookbook/dine_personnel/list',

  /** 入库单管理 */
  InboundOrderPurchaser: '/purchaser/inventory/inbound_order/list',
  /** 新增入库单 */
  InboundOrderAddPurchaser: '/purchaser/inventory/inbound_order/add',
  /** 编辑入库单 */
  InboundOrderEditPurchaser: '/purchaser/inventory/inbound_order/edit',
  /** 入库单详情 */
  InboundOrderDetailPurchaser: '/purchaser/inventory/inbound_order/detail',
  /** 入库单打印 */
  InboundOrderPrint: '/purchaser/inventory/inbound_order/print',
  /** 出库单管理 */
  OutboundOrderPurchaser: '/purchaser/inventory/outbound_order/list',
  /** 新增出库单 */
  OutboundOrderAddPurchaser: '/purchaser/inventory/outbound_order/add',
  /** 编辑出库单 */
  OutboundOrderEditPurchaser: '/purchaser/inventory/outbound_order/edit',
  /** 出库单详情 */
  OutboundOrderDetailPurchaser: '/purchaser/inventory/outbound_order/detail',
  /** 出库单打印 */
  OutboundOrderPrint: '/purchaser/inventory/outbound_order/print',
  /** 库存台账 */
  LedgerPurchaser: '/purchaser/inventory/inventory_ledger/list',
  /** 实时库存 */
  RealInventoryPurchaser: '/purchaser/inventory/real_inventory',
  /** 员工管理 */
  PurchaserEmployeeList: '/purchaser/setting/employee/list',
  /** 账户流水 */
  TurnoverListPurchaser: '/purchaser/payment_statements/turnover/list',
  /** 下达采购 */
  PurchaseSendPurchase: '/purchaser/cookbook/cookbook_manage/send_purchase',
  /** 下达申购 */
  PurchaseSendApplyPurchase: '/purchaser/cookbook/cookbook_manage/send_apply_purchase',
  /** 菜谱管理 */
  PurchaseCookbookList: '/purchaser/cookbook/cookbook_manage/list',
  /** 菜谱详情 */
  PurchaseCookbookDetail: '/purchaser/cookbook/cookbook_manage/detail',
  /** 新建自用菜谱 */
  PurchaseCookbookCreate: '/purchaser/cookbook/cookbook_manage/create',
  /** 复制自用菜谱 */
  PurchaseCookbookCopy: '/purchaser/cookbook/cookbook_manage/copy',
  /** 编辑自用菜谱 */
  PurchaseCookbookEdit: '/purchaser/cookbook/cookbook_manage/edit',
  /** 申购单 */
  ApplyPurchaseListForPurchaser: '/purchaser/apply_purchase/list',
  /** 申购单详情 */
  ApplyPurchaseDetailForPurchaser: '/purchaser/apply_purchase/detail',
  /** 编辑申购单 */
  ApplyPurchaseEditForPurchaser: '/purchaser/apply_purchase/edit',
  /** 复制申购单 */
  ApplyPurchaseCopyForPurchaser: '/purchaser/apply_purchase/copy',
  /** 新增申购单 */
  ApplyPurchaseAddForPurchaser: '/purchaser/apply_purchase/add',
  /** 申购商品明细 */
  ApplyGoodsDetailForPurchaser: '/purchaser/apply_purchase/apply_goods_detail/list',
  ReconciliationList: '/purchaser/bill/reconciliation/list',
  ReconciliationListByPayment: '/purchaser/bill/reconciliation/list',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  ReconciliationDetail: '/purchaser/bill/reconciliation/detail',
  /** 创建对账单 */
  ReconciliationCreate: '/purchaser/bill/reconciliation/create',
  /* * 从对账单创建对账单
   * @param string statementNo 采购单编号
   * @description 使用方式 ${ReconciliationEdit}/${statementNo}
   * */
  ReconciliationAddForPurchaser: '/purchaser/bill/reconciliation/purchase_edit',
  /**
   * 采购单列表
   */
  PurchaserOrderList: '/purchaser/purchase_order/list',
  /**
   * 采购单创建
   */
  PurchaserOrderCreate: '/purchaser/purchase_order/create',
  /**
   * 采购单补录
   */
  PurchaserOrderRepair: '/purchaser/purchase_order/repair',
  /**
   * 采购单批量创建
   */
  PurchaseOrderBatchCreate: '/purchaser/purchase_order/batch_create',
  /**
   * 采购单编辑
   */
  PurchaserOrderEdit: '/purchaser/purchase_order/edit',
  /**
   * 采购单复制
   */
  PurchaserOrderCopy: '/purchaser/purchase_order/copy',
  /**
   * 采购单详情
   */
  PurchaserOrderDetail: '/purchaser/purchase_order/detail',
  /** 申领单打印 */
  PurchaserOrderPrint: '/purchaser/purchase_order/print',
  /* * 编辑对账单
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationEdit}/${statementNo}
   * */
  ReconciliationEdit: '/purchaser/bill/reconciliation/edit',
  /** 采购汇总表 */
  PurchaserPurchaseReportList: '/purchaser/report/purchase_report/list',
  /** 财务汇总表 */
  PurchaserFinancialReportList: '/purchaser/report/financial_report/list',
  /** 询价公示 */
  PurchaserInquiryPublic: '/purchaser/report/inquiry_public/list',
  /** 公示结果 */
  PurchaserPublicResult: '/purchaser/report/inquiry_public/result',
  /** 询价公示-采购合同详情 */
  PurchaserInquiryPublicContractDetail: '/purchaser/report/inquiry_public/contract_detail',
  /** 计划到货明细 */
  DeliveryList: '/purchaser/purchase_order/delivery_list',
  /** 应付汇总 */
  PayableSummary: '/purchaser/bill/payable/list',
  /** 角色创建 */
  PurchaserRoleCreate: '/purchaser/role/create',
  /** 角色列表 */
  PurchaserRoleList: '/purchaser/role/list',
  /**
   * 角色编辑
   * ?roleId=${id}
   * */
  PurchaserRoleEdit: '/purchaser/role/editor',
  /** 收支管理 */
  IncomeExpenseList: '/purchaser/bill/income_expense/list',
  /** 监管方实时监控 */
  MonitorList: '/manage/monitor/list',
  /** 监管方实时监控全屏 */
  MonitorListFullScreen: '/manage/monitor/list_full_screen',
};
